/**
 * @generated SignedSource<<62fd2d24521bf1b720b287d66f16c390>>
 * @relayHash e9c7e6b4898ee3fc37292a281d66d56b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e46b239ecba29033c61fed267ed511d448fb890bb4309170ec2b9627fe77264f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookDetailQuery } from './PlaybookDetailQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookDetailQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e46b239ecba29033c61fed267ed511d448fb890bb4309170ec2b9627fe77264f",
    "metadata": {},
    "name": "PlaybookDetailQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
